import { render, staticRenderFns } from "./OrganizationBankAccounts.vue?vue&type=template&id=350d66a7"
import script from "./OrganizationBankAccounts.vue?vue&type=script&lang=js"
export * from "./OrganizationBankAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports